import { Col, Container, Row } from "reactstrap";
import { Footer, P, SVG } from "../../AbstractElements";
import { FooterLeft, FooterRight } from "../../Constant";
import { useLocation } from "react-router-dom";

const FooterCommon = () => {
  const { pathname } = useLocation();
  const darkFooter = pathname === `${process.env.PUBLIC_URL}/page-layout/footer-dark` ? "footer-dark" : "";
  const fixedFooter = pathname === `${process.env.PUBLIC_URL}/page-layout/footer-fixed` ? "footer-fix" : "";

  return (
    <Footer className={`footer ${darkFooter} ${fixedFooter}`}>
      <Container fluid>
        <Row>
          <Col md="12" className="footer-copyright footer-content">
            <P className="mb-0">{FooterLeft}</P>
            <P className="mb-0">
              {FooterRight}
              <SVG className="footer-icon" iconId="Heart" />
            </P>
          </Col>
        </Row>
      </Container>
    </Footer>
  );
};

export default FooterCommon;
